let Selection = function (windowSection) {
    this.type = '';
    this.range = null;
    this.init(windowSection);
}
let Range = function (windowRange) {
    this.startContainer = {};
    this.endContainer = {};
    this.startOffset = null;
    this.endOffset = null;
    this.init(windowRange);
};
Range.prototype.init = function (windowRange){
    this.startContainer = windowRange.startContainer;
    this.endContainer = windowRange.endContainer;
    this.startOffset = windowRange.startOffset;
    this.endOffset = windowRange.endOffset;
};
Selection.prototype.getRangeAt = function () {
    return this.range;
}
Selection.prototype.init = function (windowSection){
    let windowRange = windowSection.getRangeAt(0);
    let range = new Range(windowRange);
    this.type = windowSection.type;
    this.range = range;
}
export default Selection